<template>
<div>
  <div class="commonHeader ios" :style="{backgroundColor: diyHeaderColor}">
    <div class="headerLeft" @click="go">
      <img v-if="isWhite" src="@/assets/common/backIcon-block.png" alt="">
      <img v-else src="@/assets/common/backIcon.png" alt="">
    </div>
    <div class="headerTitle">{{titleText}}</div>
    <div class="headerRight" @click="show = true">
      <img v-if="isWhite" src="@/assets/common/customer-service-blue.png" alt="">
      <img v-else src="@/assets/common/customer-service-white.png" alt="">
    </div>
  </div>
  <commonFeedback v-if="show" :title="pageTitle" @close="show = false"></commonFeedback>
</div>
</template>

<script>
import commonFeedback from './commonFeedback.vue'
export default {
  components: { commonFeedback },
  props: {
    diyHeaderColor: {
      type: String,
      default: 'rgba(0, 0, 0, 0)'
    },
    titleText: {
      type: String,
      default: ''
    },
    pageTitle: {
      type: String,
      default: ''
    },
    isWhite: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    go() {
      this.$javaGet("returnH5");
    }
  }
}
</script>

<style scoped lang="less">
.commonHeader {
  width: 100%;
  min-height: 55px;
  padding: 6px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  &.ios {
    padding-top: calc(var(--app-status-bar-height) + 12px);
  }
  .headerLeft {
    img {
      width: 20px;
      height: 20px;
    }
  }
  .headerTitle {
    font-size: 16px;
    color: #222222;
    font-weight: 500;
  }
  .headerRight {
    img {
      width: 24px;
      height: 24px;
    }
  }
}

</style>